import { ethers } from "ethers";
import LedgerTransport from "@ledgerhq/hw-transport-webusb";
import ledgerAppLibs from "./libs";
import ERRORS from "./errors";
import utils from "../lib/utils";
const FAILS_THRESHOLD = 300; // 150 sec
const REQUIRE_VERSION = "1.9.0";

let fails = 0;
const eventQueue = utils.createQueue();

const Ledger = () => {
  const LedgerApp = ledgerAppLibs.ethereum;
  let ledgerApp = null;
  fails = 0;
  const connect = async ({ skipFailsThreshold }) => {
    try {
      const transport = await LedgerTransport.create();
      const app = new LedgerApp(transport);
      const { version } = await app.getAppConfiguration();
      if (!isVersionValid(version, REQUIRE_VERSION)) {
        throw new Error(
          `Outdated version: Please update Ledger Ethereum App to version ${REQUIRE_VERSION} or higher.`
        );
      }
      ledgerApp = app;
      return ledgerApp;
    } catch (error) {
      if (skipFailsThreshold || fails > FAILS_THRESHOLD) {
        throw error;
      }
      fails++;
      await utils.sleep(500);
      return connect({ skipFailsThreshold });
    }
  };

  const getHdPathLive = (accountNum, addressIdx) => {
    return `m/44'/60'/${accountNum}'/0/${addressIdx}`;
  };

  const getHdPathLegacy = (accountNum) => {
    return `m/44'/60'/0'/${accountNum}`;
  };

  const getHdPath = (path) => {
    if (path.length === 4) return getHdPathLegacy(path[3]);
    return getHdPathLive(path[2], path[4]);
  };

  const getPubKey = async () => {
    throw new ReferenceError("Ethereum: getPubKey is not supported");
  };

  const getPubKeyEncoded = async () => {
    throw new ReferenceError("Ethereum: getPubKeyEncoded is not supported");
  };

  const getAddress = async (path) => {
    if (!ledgerApp) throw new Error(ERRORS.CANNOT_CONNECT);
    const hdPath = getHdPath(path);
    const { address } = await eventQueue.push(
      ledgerApp.getAddress.bind(null, hdPath)
    );
    return { address };
  };

  const signTransaction = async (path, rawTx) => {
    const hdPath = getHdPath(path);
    const tx = {
      type: 2,
      nonce: rawTx.nonce,
      maxFeePerGas: rawTx.maxFeePerGas,
      maxPriorityFeePerGas: rawTx.maxPriorityFeePerGas,
      gasLimit: rawTx.gas,
      to: rawTx.to,
      value: rawTx.value,
      data: rawTx.data,
      chainId: rawTx.chainId || 1,
    };
    const rawTxHex = ethers.utils.serializeTransaction(tx);
    const result = await eventQueue.push(
      ledgerApp.signTransaction.bind(null, hdPath, rawTxHex.slice(2))
    );
    const signedTx = ethers.utils.serializeTransaction(
      tx,
      "0x" + result.r + result.s + result.v
    );
    const { hash: txHash } = ethers.utils.parseTransaction(signedTx);
    return { txHash, signedTx };
  };

  const sign = async (path, message) => {};

  const verifySignature = async (path, message, signature) => {};

  const isVersionValid = (current, target) => {
    return (
      Number(current.replace(/\D/g, "")) >= Number(target.replace(/\D/g, ""))
    );
  };

  return {
    connect,
    getPubKey,
    getPubKeyEncoded,
    getAddress,
    sign,
    signTransaction,
    verifySignature,
  };
};

export default Ledger;
